import React, {ComponentType, PropsWithChildren, useMemo} from 'react';
import ErrorBoundary                                 from 'components/ErrorBoundary';
import {createGlobalStyles, createReferralTheme}      from '../../config/muiThemeNew';
import ThemeProvider                                  from '@mui/material/styles/ThemeProvider';
import GlobalStyles                                   from '@mui/material/GlobalStyles';
import {RouteComponentProps, withRouter}              from 'react-router';
import {ReferralBrandProvider, useReferralBrand}      from 'components/Referral/ReferralBrandProvider';

function BrandedTheme({children}: PropsWithChildren) {
  const {brand} = useReferralBrand();
  const theme = useMemo(() => createReferralTheme(brand), [brand]);
  const styles = useMemo(() => createGlobalStyles(brand), [brand]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={styles} />
      <ErrorBoundary>{children}</ErrorBoundary>
    </ThemeProvider>
  )
}

function Secondary({children, location}: PropsWithChildren<RouteComponentProps>) {
  return (
    <ReferralBrandProvider pathname={location.pathname}>
      <BrandedTheme>{children}</BrandedTheme>
    </ReferralBrandProvider>
  )
}

// Routes render this as <Layout>{children}</Layout>; the router props come from withRouter.
export default withRouter(Secondary) as ComponentType<PropsWithChildren>;
